import { el, mount } from 'redom';
import { ARROW_ICON } from './icons';
import { MouseCatcher } from '../Catchers/mouseCatcher';

export class UiArrow {
    private containerStyle = {
        position: 'absolute',
        left: '0px',
        bottom: '0px',
        width: '150px',
        height: '100px',
        zIndex: '10'
    }

    private arrowStyle = {
        position: 'absolute',
        padding: '10px',
        margin: '5px',
        background: 'white',
        borderRadius: '3px',
        border: '0px',
        boxShadow: 'grey 0px 0px 7px'

    }

    constructor(parent: HTMLElement, mouseCatcher: MouseCatcher) {
        let leftArrow;
        let rightArrow;
        let upArrow;
        let downArrow;
        const configurationContainer = el('div', { style: this.containerStyle }, [
            el('div',
                {
                    onclick: () => { mouseCatcher.keyboardDrag('ArrowLeft'); },
                    style: { ...this.arrowStyle, transform: 'translate(0px, 50px) rotate(90deg)' }
                },
                leftArrow = el('div')),
            el('div',
                {
                    onclick: () => { mouseCatcher.keyboardDrag('ArrowRight'); },
                    style: { ...this.arrowStyle, transform: 'translate(100px, 50px) rotate(-90deg)' }
                },
                rightArrow = el('div')),
            el('div',
                {
                    onclick: () => { mouseCatcher.keyboardDrag('ArrowUp'); },
                    style: { ...this.arrowStyle, transform: 'translate(50px, 00px) rotate(180deg)' }
                },
                upArrow = el('div')),
            el('div',
                {
                    onclick: () => { mouseCatcher.keyboardDrag('ArrowDown'); },
                    style: { ...this.arrowStyle, transform: 'translate(50px, 50px) rotate(0deg)' }
                },
                downArrow = el('div')),
        ]);

        leftArrow.innerHTML = ARROW_ICON;
        rightArrow.innerHTML = ARROW_ICON;
        upArrow.innerHTML = ARROW_ICON;
        downArrow.innerHTML = ARROW_ICON;

        mount(parent, configurationContainer);
    }
}
